import React, { useRef } from "react";
import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import Slider from "react-slick";

export default function AboutEach() {
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1500,
    slidesToShow: 4,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
    autoplay: false,
    pauseOnHover: false,
    cssEase: "ease",
    draggable: false,
    swipe: false,
    responsive: [
        {
          breakpoint: 991,
          settings: { slidesToShow: 3, draggable: true, swipe: true, autoplay: true, },
        },
        {
            breakpoint: 767,
            settings: { slidesToShow: 2, draggable: true, swipe: true, autoplay: true, },
        },
        {
            breakpoint: 599,
            settings: { slidesToShow: 1, draggable: true, swipe: true, autoplay: true,}
        },
    ],
  };

    const CustomArrows = () => (
        <>
        <div className="default-arrowleft default-mobilearrow" onClick={() => sliderRef.current.slickPrev()}>
            <Icons name="arrowLeft" />
        </div>
        <div className="default-arrowright default-mobilearrow" onClick={() => sliderRef.current.slickNext()}>
            <Icons name="arrowRight" />
        </div>
        </>
    );

  return (
    <>
    <section className="aboutpage-piece">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-8">
                    <div className="aboutpiece-head">  
                        <h4 className="heading">Each Piece</h4>
                        <p>Through its heartfelt and artisanal approach, each piece is crafted with love and precision not as clothing for a season, but as a timeless reflection of craftsmanship, emotion, and enduring beauty.</p>
                    </div>
                </div> 
                    
                <div className="col-lg-12">   
                    <div className="aboutpiece-slider">  
                        <Slider {...settings} ref={sliderRef}>
                            <div>
                                <div className="aboutpiece-slidebox">
                                    <Link to={"/wedding-dress-designers"}>
                                        <img src="/image/about-piece-1.webp" className="img-responsive" alt="Piece" loading="lazy"/>
                                        <h4 className="heading">Banno</h4>
                                    </Link>
                                </div>
                            </div>

                            <div>
                                <div className="aboutpiece-slidebox">
                                    <Link to={"/haldi-dresses"}>
                                        <img src="/image/about-piece-2.webp" className="img-responsive" alt="Piece" loading="lazy"/>
                                        <h4 className="heading">Kanak</h4>
                                    </Link>
                                </div>
                            </div>

                            <div>
                                <div className="aboutpiece-slidebox">
                                    <Link to={"/mehandi-dresses"}>
                                        <img src="/image/about-piece-3.webp" className="img-responsive" alt="Piece" loading="lazy"/>
                                        <h4 className="heading">Anjum</h4>
                                    </Link>
                                </div>
                            </div>

                            <div>
                                <div className="aboutpiece-slidebox">
                                    <Link to={"/sangeet-suit"}>
                                        <img src="/image/about-piece-4.webp" className="img-responsive" alt="Piece" loading="lazy"/>
                                        <h4 className="heading">Ada</h4>
                                    </Link>
                                </div>
                            </div>
                        </Slider>
                        <CustomArrows />
                    </div>

                    <h4 className="gradient-color wow animate__animated animate__flipInX" data-wow-duration="1.2s" data-wow-delay="0.2s">Love, <br/>Sonam Brahme</h4>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}
